import initialStates from '../../initialStates';
import {
    CLEAR_PRODUCT_TAG_STATE,
    CREATE_PRODUCT_TAG_SUCCESS,
    FETCH_PRODUCT_TAG_LIST_FAILURE,
    FETCH_PRODUCT_TAG_LIST_REQUEST,
    FETCH_PRODUCT_TAG_LIST_SUCCESS,
    INACTIVATE_PRODUCT_TAG_REQUEST,
    INACTIVATE_PRODUCT_TAG_SUCCESS,
    INACTIVATE_PRODUCT_TAG_FAILURE,
    ACTIVATE_PRODUCT_TAG_REQUEST,
    ACTIVATE_PRODUCT_TAG_SUCCESS,
    ACTIVATE_PRODUCT_TAG_FAILURE,
} from './productTag-actions';

const productTagReducer = (state = initialStates.productTag, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_PRODUCT_TAG_LIST_REQUEST:
        newState = Object.assign({}, state, { isLoading: true });
        break;
    case FETCH_PRODUCT_TAG_LIST_SUCCESS:
        newState = Object.assign({}, state, {
            isLoading: false,
            list: action.data.content,
            page: action.data.number,
            size: action.data.size,
            totalElements: action.data.totalElements,
        });
        break;
    case FETCH_PRODUCT_TAG_LIST_FAILURE:
        newState = Object.assign({}, state, { isLoading: false });
        break;

    case INACTIVATE_PRODUCT_TAG_REQUEST:
    case ACTIVATE_PRODUCT_TAG_REQUEST:
        newState = Object.assign({}, state, { isToggling: true });
        break;
    case INACTIVATE_PRODUCT_TAG_SUCCESS:
    case ACTIVATE_PRODUCT_TAG_SUCCESS:
        newState = Object.assign({}, state, { isToggling: false });
        break;
    case INACTIVATE_PRODUCT_TAG_FAILURE:
    case ACTIVATE_PRODUCT_TAG_FAILURE:
        newState = Object.assign({}, state, { isToggling: false });
        break;

    case CLEAR_PRODUCT_TAG_STATE:
        newState = initialStates.productTag;
        break;
    case CREATE_PRODUCT_TAG_SUCCESS:
        newState = {
            ...state,
            selectedTag: action.data,
        };
        break;
    default:
        newState = state;
    }
    return newState;
};

export default productTagReducer;
